// Authentication feature flags configuration
export const authConfig = {
  // Email/Password authentication
  email: {
    enabled: import.meta.env.VITE_AUTH_EMAIL_ENABLED === 'true',
    name: 'Email',
  },

  // Social authentication providers
  google: {
    enabled: import.meta.env.VITE_AUTH_GOOGLE_ENABLED === 'true',
    name: 'Google',
  },

  facebook: {
    enabled: import.meta.env.VITE_AUTH_FACEBOOK_ENABLED === 'true',
    name: 'Facebook',
  },
}

// Helper to get enabled auth methods
export const getEnabledAuthMethods = () =>
  Object.entries(authConfig)
    .filter(([_, config]) => config.enabled)
    .map(([key, config]) => ({ key, ...config }))

// Helper to check if any social auth is enabled
export const hasSocialAuth = () => authConfig.google.enabled || authConfig.facebook.enabled

// Helper to check if any auth method is enabled
export const hasAnyAuthMethod = () => authConfig.email.enabled || hasSocialAuth()
